import { ReactNode } from "react";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useIntl } from "react-intl";

import { dateLocaleMap } from "lib/dateLocaleMap";

export function LegacyMuiLocalizationProvider(props: { children: ReactNode }) {
  const intl = useIntl();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={dateLocaleMap[intl.locale] ?? dateLocaleMap["en"]}
    >
      {props.children}
    </LocalizationProvider>
  );
}
